import { Component, Prop } from '@stencil/core';


@Component({
  tag: 'tip-date'
})
export class TipDate {
  @Prop() value: string;

  render() {
    if (this.value) {
      let dateObj = new Date(this.value);
      return `${dateObj.getMonth() + 1}/${dateObj.getDate()}/${dateObj.getFullYear()}`
    }
    return ''

  }
}
